import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0844ce48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signup-page mx-auto p-3 box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "注册DB知乎账户", -1))
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "邮箱地址", -1))
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "昵称", -1))
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "密码", -1))
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "重复密码", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn btn-primary" }, "注册新用户", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_validate_input = _resolveComponent("validate-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Validate_form = _resolveComponent("Validate-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Validate_form, {
      onFormSubmit: _ctx.onFormSubmit,
      class: "from"
    }, {
      submit: _withCtx(() => [
        _hoisted_11
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_validate_input, {
            type: "email",
            placeholder: "请输入邮箱地址",
            rules: _ctx.emailRules,
            modelValue: _ctx.formData.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.email) = $event)),
            ref: "inputRef"
          }, null, 8, ["rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_validate_input, {
            type: "required",
            rules: _ctx.nameRules,
            placeholder: "请输入昵称",
            modelValue: _ctx.formData.nickName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.nickName) = $event))
          }, null, 8, ["rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_validate_input, {
            type: "password",
            placeholder: "请输入密码",
            rules: _ctx.passwordRules,
            modelValue: _ctx.formData.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.password) = $event))
          }, null, 8, ["rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_validate_input, {
            type: "password",
            placeholder: "请再次输入密码",
            rules: _ctx.repeatPasswordRules,
            modelValue: _ctx.formData.repeatPassword,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.repeatPassword) = $event))
          }, null, 8, ["rules", "modelValue"])
        ]),
        _createVNode(_component_router_link, {
          to: "/Login",
          class: "login"
        }, {
          default: _withCtx(() => [
            _createTextVNode("还没有账户？去注册一个新的吧！")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onFormSubmit"])
  ]))
}